import React from 'react';
import { TRAINING_VARIANTS } from '../../data/cta-variants';
import { TrainingBodyContent } from './components/TrainingBodyContent';
import { TrainingHeader } from './components/TrainingHeader';
import { TrainingMethod } from './components/TrainingMethod';
import { TrainingMethodNavBlock } from './components/TrainingMethodNavBlock';
import { TrainingOverview } from './components/TrainingOverview';
import { TrainingUGCSection } from './components/TrainingUGCSection';
import { ArticleShareIcons } from '../../components/ArticleShareIcons';
import { RelatedArticlesCarousel } from '../../components/RelatedArticlesCarousel';
import { RotatingBouncer } from '../../components/RotatingBouncer';
import { CamelizedTrainingGuideResponse } from '../../types/app/training-guide';
import { Container } from '../../wag-react/components/Container';
import { AuthorBlock } from '../../wag-react/components/author-block/AuthorBlock';
import { Divider } from '../../wag-react/core-components/divider';
export type TrainingGuidePageContainerProps = CamelizedTrainingGuideResponse & {
  animalTypeSlug: string;
  nextPageUrl?: string;
};
export const TrainingGuidePageContainer = ({
  animalTypeSlug,
  author,
  body,
  breadcrumbs,
  category,
  difficulty,
  heroImageUrl,
  nextPage,
  nextPageUrl,
  numQuestionsStories,
  questions,
  readTime,
  relatedArticles,
  shareUrls,
  slug,
  successStories,
  trainingDuration,
  trainingMethods,
  title
}: TrainingGuidePageContainerProps) => <>
    <Container as="article" maxWidth="832px" position="relative" px={['unset', '24px']} data-sentry-element="Container" data-sentry-source-file="index.tsx">
      <ArticleShareIcons title={title} value={shareUrls} data-sentry-element="ArticleShareIcons" data-sentry-source-file="index.tsx" />

      <TrainingHeader breadcrumbs={breadcrumbs} title={title} heroImageUrl={heroImageUrl} numQuestionsStories={numQuestionsStories} readTime={readTime} shareUrls={shareUrls} data-sentry-element="TrainingHeader" data-sentry-source-file="index.tsx" />

      <TrainingOverview category={category} difficulty={difficulty} duration={trainingDuration} mb={2} data-sentry-element="TrainingOverview" data-sentry-source-file="index.tsx" />

      <TrainingMethodNavBlock methods={trainingMethods} mb={['16px', '40px']} data-sentry-element="TrainingMethodNavBlock" data-sentry-source-file="index.tsx" />

      <TrainingBodyContent body={body} data-sentry-element="TrainingBodyContent" data-sentry-source-file="index.tsx" />

      {trainingMethods.map(({
      coverImageUrl,
      htmlId,
      name,
      recommendationRank,
      totalVotes: numVotes,
      trainingMethodSteps
    }) => <TrainingMethod key={name} htmlId={htmlId} image={{
      url: coverImageUrl,
      alt: `${name} method for ${title}`
    }} name={name} numVotes={numVotes} recommendationRank={recommendationRank} steps={trainingMethodSteps} mb={[0, '40px']} />)}

      {author.name && <AuthorBlock as="address" fontStyle="normal" value={author} px={['16px', 0]} />}

      <TrainingUGCSection animalTypeSlug={animalTypeSlug} nextPage={nextPage} nextPageUrl={nextPageUrl} questions={questions} slug={slug} successStories={successStories} data-sentry-element="TrainingUGCSection" data-sentry-source-file="index.tsx" />

      <Divider mt="60px" data-sentry-element="Divider" data-sentry-source-file="index.tsx" />

      {/* TODO: Extend width based on design */}
      <RelatedArticlesCarousel contentType="Training" value={relatedArticles} data-sentry-element="RelatedArticlesCarousel" data-sentry-source-file="index.tsx" />
    </Container>

    <RotatingBouncer variants={TRAINING_VARIANTS} contentType="training_guide" data-sentry-element="RotatingBouncer" data-sentry-source-file="index.tsx" />
  </>;